import React from "react";
import CrudPage, { Badge } from "@/components/CrudPage";
import { formatDate, formatKM } from "@/lib/format";

const METHODS = ["Gotovina", "Kartica"];

export default function Pos() {
  const columns = [
    { key: "issue_date", label: "Datum", render: (r) => formatDate(r.issue_date), export: (r) => r.issue_date },
    { key: "supplier_name", label: "Firma", render: (r) => <span className="font-medium whitespace-nowrap">{r.supplier_name}{r.invoice_number ? <span className="text-muted-foreground font-mono text-xs ml-1">#{r.invoice_number}</span> : null}</span> },
    { key: "payment_method", label: "Plaćeno", render: (r) => <Badge tone={r.payment_method === "Kartica" ? "info" : "muted"}>{r.payment_method || "—"}</Badge> },
    { key: "category", label: "Kategorija", render: (r) => <Badge tone="muted">{r.category || "—"}</Badge> },
    { key: "amount", label: "Iznos (sa PDV)", render: (r) => <span className="tabular-nums font-semibold">{formatKM(r.amount)}</span>, export: (r) => r.amount },
    { key: "pdv_mode", label: "PDV", render: (r) => { const m = r.pdv_mode || (r.pdv_deductible ? "Odbitni PDV" : "PDV (nije odbitni)"); return <Badge tone={m === "Odbitni PDV" ? "success" : m === "Bez PDV-a" ? "info" : "muted"}>{m}</Badge>; }, export: (r) => r.pdv_mode || "PDV (nije odbitni)" },
    { key: "reinvoiced", label: "Prefakturisano", render: (r) => (r.reinvoiced ? <Badge tone="warning">Kupcu</Badge> : "—"), export: (r) => (r.reinvoiced ? "Da" : "") },
  ];

  const fields = [
    {
      key: "_picker", label: "Odaberi spremljenu firmu (imenik)", type: "directory", full: true,
      directory: {
        endpoint: "suppliers", placeholder: "Odaberi iz imenika...",
        getLabel: (s) => s.supplier_name,
        createFields: [
          { key: "supplier_name", label: "Firma", required: true },
          { key: "ziro_racun", label: "Broj žiro računa (opcionalno)" },
        ],
        map: (s) => ({ supplier_name: s.supplier_name }),
      },
    },
    { key: "supplier_name", label: "Naziv firme", required: true },
    { key: "invoice_number", label: "Broj računa" },
    { key: "payment_method", label: "Način plaćanja", type: "select", options: METHODS, required: true },
    { key: "category", label: "Kategorija troška", type: "category", categoryType: "fakture" },
    { key: "issue_date", label: "Datum računa", type: "date" },
    { key: "amount", label: "Iznos sa PDV-om (KM)", type: "number", required: true },
    { key: "pdv_mode", label: "PDV status", type: "select", options: ["Odbitni PDV", "PDV (nije odbitni)", "Bez PDV-a"] },
    { key: "reinvoiced", label: "Prefakturisano kupcu", type: "checkbox", checkboxLabel: "Naplaćeno/fakturisano kupcu — NE ide u trošak (samo evidencija)" },
    { key: "note", label: "Napomena", type: "textarea", full: true },
  ];

  return (
    <CrudPage
      title="POS računi"
      subtitle="Mali računi plaćeni gotovinom ili karticom. Automatski ulaze u mjesečne troškove."
      endpoint="pos"
      columns={columns}
      fields={fields}
      testid="pos"
      emptyDefaults={{ payment_method: "Gotovina", issue_date: new Date().toISOString().slice(0, 10), pdv_mode: "PDV (nije odbitni)", reinvoiced: false }}
      filterOptions={{ key: "payment_method", label: "Plaćeno", options: METHODS }}
    />
  );
}
